export const REMOVE_ALERT = "REMOVE_ALERT";
export const SET_ALERT = "SET_ALERT";
export const SET_BACKGROUND_ACTION_ID = "SET_BACKGROUND_ACTION_ID";
